import { FullscreenCentered, Loader } from '@diana/core';

export function AppLoading() {
  return (
    <FullscreenCentered>
      <Loader simple />
    </FullscreenCentered>
  );
}
